import { render, staticRenderFns } from "./DashBoardCompras.vue?vue&type=template&id=5049745f"
import script from "./DashBoardCompras.vue?vue&type=script&lang=js"
export * from "./DashBoardCompras.vue?vue&type=script&lang=js"
import style0 from "./DashBoardCompras.vue?vue&type=style&index=0&id=5049745f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports